import * as React from "react";

import { cn } from "@replohq/lattice/utils/cn";
import { BetaIntroVideo } from "@v2/features/agent-beta/components/BetaIntroVideo";

export function AgentCommerceStory({
  variant,
}: {
  variant: "carousel" | "modal";
}) {
  const isCarousel = variant === "carousel";
  const isCentered = variant !== "modal";

  return (
    <div
      className={cn(
        "flex flex-col",
        isCentered ? "items-center gap-3 text-center" : "gap-6",
      )}
    >
      <div
        className={cn(
          "flex flex-col gap-2",
          isCentered && "items-center text-center",
        )}
      >
        <h2
          className={cn(
            "font-editorial text-3xl leading-tight",
            isCarousel ? "text-brand-seashell" : "italic text-default",
          )}
        >
          The new Replo runs the whole launch
        </h2>
        <p
          className={cn(
            "leading-relaxed",
            isCarousel
              ? "max-w-[430px] text-sm text-brand-seashell/65"
              : "text-base text-muted",
          )}
        >
          Research the market, build the funnel, connect your stack, and see
          what sells from one chat.
        </p>
      </div>

      {variant === "modal" && <BetaIntroVideo />}
    </div>
  );
}
